import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-slate-50 to-slate-100 px-4">
      <div className="max-w-lg text-center bg-white rounded-2xl shadow-lg p-10">
        <h1 className="text-7xl font-extrabold text-slate-900 mb-4">
          404
        </h1>

        <h2 className="text-2xl font-semibold text-slate-800 mb-2">
          Sidan hittades inte
        </h2>

        <p className="text-slate-600 mb-8">
          Länken du följde är felaktig eller sidan har flyttats.
          Du kan gå tillbaka till startsidan eller kontakta oss.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center rounded-xl bg-slate-900 px-6 py-3 text-white font-medium hover:bg-slate-800 transition"
          >
            Till startsidan
          </Link>
        </div>
      </div>
    </div>
  );
}
